import React, { useEffect, useState } from "react";
import { Card, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import CardBody from "../../../components/Card/CardBody";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import _ from "lodash";
import { useFormContext } from "react-hook-form";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";

export default function Piggy(...props) {
  const { vestigingId } = useFormContext();
  const [piggyProducts, setPiggyProducts] = useState([]);
  const [searchText, setSearchText] = useState([]);
  const isLoading = _.isEqual([], piggyProducts);
  const productId = props[0]?.model?.id;
  const handleSearch = (e) => setSearchText(e.target.value);

  useEffect(() => {
    async function fetchPiggyProducts() {
      if (piggyProducts.length === 0) {
        const res = await axios.get(`core/piggyRewardJamezzProducts?vestigingId=${vestigingId}`);
        setPiggyProducts(res.data.data);
      }
    }

    fetchPiggyProducts();
  }, [piggyProducts]);

  const selectedPiggyProduct = piggyProducts.filter(function (piggyProduct) {
    return parseInt(piggyProduct.artikelid) === parseInt(productId);
  });

  let piggyProductsWithoutSelected = piggyProducts.filter(function (piggyProduct) {
    return parseInt(piggyProduct.artikelid) !== parseInt(productId);
  });

  if (searchText.length) {
    piggyProductsWithoutSelected = piggyProductsWithoutSelected.filter((piggyProduct) => {
      return new RegExp(`.*${searchText}.*`, "i").test(piggyProduct.piggyItemName + " " + piggyProduct.piggyItemId);
    });
  }

  const products = piggyProductsWithoutSelected.map(function (piggyProduct, index) {
    return (
      <ListItem key={piggyProduct.piggyItemId} style={index % 2 ? { background: "#e3e3e352" } : { background: "#fff" }}>
        <ListItemText primary={piggyProduct.piggyItemName} secondary={`ID: ${piggyProduct.piggyItemId}`} />
        <ListItemSecondaryAction>
          <IconButton
            aria-label={"delete"}
            edge={"end"}
            onClick={() => {
              if (selectedPiggyProduct.length) {
                axios.post("core/piggyUpdateReward", {
                  sales_area_id: vestigingId,
                  reward_uuid: selectedPiggyProduct[0].uuid,
                  attributes: {
                    artikelid: 0,
                  },
                });
              }

              axios
                .post("core/piggyUpdateReward", {
                  sales_area_id: vestigingId,
                  reward_uuid: piggyProduct.uuid,
                  attributes: {
                    artikelid: productId,
                  },
                })
                .then(() => {
                  setPiggyProducts([]);
                });
            }}
          >
            <AddIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    );
  });

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Card>
        <CardBody>
          <h3>
            <TranslationWrapper tDefault={"Piggy product"} tKey={"producten.form.algemeen.headers.piggy"} />
          </h3>

          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
            id={"filled-full-width"}
            label={<TranslationWrapper tKey={"Search"} />}
            margin={"normal"}
            onChange={handleSearch}
            placeholder={"..."}
            style={{ margin: 8 }}
            variant={"filled"}
          />

          <List>
            {selectedPiggyProduct.length ? (
              <ListItem key={selectedPiggyProduct[0].piggyItemId} style={{ background: "#32b73247" }}>
                <ListItemText
                  primary={selectedPiggyProduct[0].piggyItemName}
                  secondary={`ID: ${selectedPiggyProduct[0].piggyItemId}`}
                />
                <ListItemSecondaryAction>
                  <IconButton
                    aria-label={"delete"}
                    edge={"end"}
                    onClick={() => {
                      axios
                        .post("core/piggyUpdateReward", {
                          sales_area_id: vestigingId,
                          reward_uuid: selectedPiggyProduct[0].uuid,
                          attributes: {
                            artikelid: 0,
                          },
                        })
                        .then(() => {
                          setPiggyProducts([]);
                        });
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ) : (
              <div />
            )}

            {!isLoading ? products : <CircularProgress />}
          </List>
        </CardBody>
      </Card>
    </div>
  );
}
